module.exports = __webpack_public_path__ + "img/tickets.c8d3840e.svg";